import * as appData from '../models/appModels';
import * as actionTypes from '../actions/actionTypes';


export default {
    initData: appData.INIT_DATA,
    trackingData:appData.TRACKING_DATA,
    contentData: {
        contentLoaded: false
    },
    userData:{},
    navigation: {},
    dialogPopup: {
        render: false
    },
    contentToolTip: {
        render: false,
        content: ""
    },
    clickRevealDialog: {
        render: false
    },
    assetDialog: {
        render: false
    },
    screenDialog: {
        render: false
    },
    titles:  appData.TITLES,
    ajaxCallsInProgress: 0,
    displayMainMenu:actionTypes.STATUS_CLOSED,
    displayResources:actionTypes.STATUS_CLOSED,
    displayNotes:actionTypes.STATUS_CLOSED,
    resourceProps: appData.RESOURCE_PROPS,
    audio:{
        audioRef:"",
        audioAllowed: true
    },
    fontSize: appData.FONT_SIZE
};






/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/